import React from 'react';

import trumpetFilledIcon from '@assets/img/icons/trumpet-filled.svg';
import { HorizontalSpace } from '@components/HorizontalSpace';
import MUIIconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  bannerContainer: {
    ...common.flexInline,
    minHeight: '36px',
    '&.color-warning': {
      background: '#CF3F1B',
    },
    '&.color-accent': {
      background: `linear-gradient(180deg, ${theme.palette.accent.dark} 0%, ${theme.palette.accent.main} 100%)`,
    },
  },
  bannerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 1400,
    margin: 'auto',
    padding: '0 1rem',
    ...common.middleText,
    ...common.textWhite,
    [theme.breakpoints.down('sm')]: {
      padding: '5px 10px',
    },
  },
  bannerText: {
    flexGrow: 1,
    overflow: 'hidden',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
  },
}));

interface NotificationBannerProps {
  mainText: string;
  color: 'accent' | 'warning';
  right?: React.ReactNode;
  onClose?: () => void;
  onClick?: () => void;
  className?: string;
}

export const NotificationBanner: React.FC<NotificationBannerProps> = (props) => {
  const { onClick, onClose, right, mainText, color, className } = props;
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div
      onClick={onClick}
      className={clsx(
        classes.bannerContainer,
        `color-${color}`,
        className,
        onClick !== undefined && classes.baseButton,
      )}
    >
      <div className={classes.bannerInner}>
        <img src={trumpetFilledIcon} style={{ height: 16, width: 16 }} />
        <HorizontalSpace width={19} />
        <div className={classes.bannerText}>{mainText}</div>
        {right}
      </div>
      {onClose && (
        <MUIIconButton
          className={classes.closeButton}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onClose();
          }}
        >
          <CloseIcon style={{ height: 10, width: 10 }} htmlColor={'white'} />
        </MUIIconButton>
      )}
    </div>
  );
};
